<template>
  <div>
    <nav-breadcrumb :menu="[{label: '提款申请'}]"/>
    <el-row>
      <el-col class="grid-content bg-purple">
        <el-row>
          <el-tabs v-model="applicationStatus">
            <el-tab-pane label="待审核" name="Pending Approval" />
            <el-tab-pane label="已审核" name="Approved, Rejected" />
          </el-tabs>
          <div class="xzpadd10">
            <data-table
              :tableData="financingApplyingListData"
              :columns="financingApplyingListColumns"
              :filters="filters"
              :pageSize.sync="pageSize"
              :page.sync="page"
            ></data-table>
          </div>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import xhr from '../../../utils/xhr'
  import moment from 'moment'
  import Status2CN from "../../../filters/Status2CN";
  import {xmlBuildQuery} from "../../../filters/CommonActions";
  import {formatMoney} from "../../../filters/CommonFilters";

  export default {
    name: 'ServerAdminFinancingApplyingList',
    data() {
      return {
        applicationStatus: 'Pending Approval',
        page: 1,
        pageSize: 10,
        financingApplyingListData: {},
        filters: {
          form: {
            fi__applicationNo: '',
            u__customerName: '',
            i__contactTelNo:'',
            fi__intendedUse:'',
            ct__debtorName: '',
            ct__productName: '',
            fi__applicationDate: [],
            fi__applicationStatus: ''
          },
          columns: [
            {
              label: '申请编号',
              component: 'el-input',
              field: 'fi__applicationNo'
            },
            {
              label: '客户名称',
              component: 'el-input',
              field: 'u__customerName'
            },
            {
              label: '手机号',
              component: 'el-input',
              field: 'i__contactTelNo'
            },
            {
              label: '贷款用途',
              component: 'el-input',
              field: 'fi__intendedUse'
            },
            {
              label: '申请日期',
              component: 'date-range-picker',
              field: 'fi__applicationDate'
            },
/*            {
              label: '申请状态',
              component: 'el-select',
              field: 'fi__applicationStatus',
              options:[
                {
                  label: '审核通过',
                  value: 'Approval'
                },
                {
                  label: '审核未通过',
                  value: 'Rejected'
                }
              ]
            }*/
          ],
          onSubmit:()=>{
            this.page = 1
            this.getCustomerApplyingFinancingList()
          }
        }
      }
    },
    computed : {
      financingApplyingListColumns: function() {
        return [
          {
            name: '申请编号',
            field: 'fi__applicationNo'
          },
          {
            name: '客户姓名',
            field: 'u__customerName'
          },
          {
            name: '客户手机号',
            field: 'i__contactTelNo'
          },
          // {
          //   name: '供应链',
          //   field: 'ct__debtorName'
          // },
          {
            name: '贷款用途',
            field: 'fi__intendedUse',
          },
          {
            name: '贷款金额(元)',
            field: 'fi__totalAmount',
            formatter:function(r,c,v){
              return formatMoney(v)
            }
          },
          {
            name: '贷款利率(%)',
            field: 'fi__interestRate',
            formatter: function (r,c,v) {
              return v +'% (' +  Status2CN(r.fi__interestType)+')'
            }
          },
         /* {
            name: '开始日',
            field: 'fi__startDate',
            formatter: function (r,c,v) {
              return moment(v).format('YYYY-MM-DD')
            }
          },
          {
            name: '到期日',
            field: 'fi__endDate',
            formatter: function (r,c,v) {
              return moment(v).format('YYYY-MM-DD')
            }
          },*/
          {
            name: '申请时间',
            field: 'fi__applicationDate',
            formatter: function (r,c,v) {
              return moment(v).format('YYYY-MM-DD hh:mm')
            }
          },
          {
            name: '状态',
            field: 'fi__applicationStatus',
            formatter: function (r,c,v) {
              return Status2CN(v)
            }
          },
          {
            name: '操作',
            opts:
              [
                {
                  class: 'el-icon-success',
                  name: '审核',
                  conditions: (row) => row.fi__applicationStatus == 'Pending Approval',
                  clickHandler: (index, row)=>{
                    this.viewDetail(index, row)
                  }

                },
                {
                  class: 'el-icon-info',
                  name: '查看',
                  clickHandler: (index, row)=>{
                    this.viewDetail(index, row)
                  }
                },
              ]

          }
        ]
      },
      filterParams: {
        get: function() {
          return {
            pageSize: this.pageSize,
            pageOffset: (this.page - 1) * this.pageSize,
            'xlist.search.fi.applicationStatus': this.applicationStatus,
            'xlist.search.fi.applicationStatus.op': 'in',
            'xlist.sort.dataField': 'fi.applicationDate',
            'xlist.sort.order': 'desc'
          }
        },
        set:function (newVal) {

        }
      }
    },
    watch: {
      filterParams: function () {
        this.getCustomerApplyingFinancingList()
      }
    },
    mounted() {
      this.getCustomerApplyingFinancingList()
    },
    methods: {
      getCustomerApplyingFinancingList: function () {
        xhr.getCustomerApplyingFinancingList(
          Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
          res=> {
          try {
            this.financingApplyingListData = res.data
          }catch(e){

          }
        })

      },
      viewDetail: function (index, row) {
        try {
          this.$router.push({path: 'ApplyingDetail?fi.applicationId='+ row.fi__applicationId})
        }
        catch (e) {

        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/ServiceAdmin/FinancingApplyingList.vue